import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Button,
    Card,
    Container,
    Row,
    Col
} from "react-bootstrap";
import './Authenticator.css';
import { FaEnvelope, FaSms, FaAngleLeft } from 'react-icons/fa';
import Form from 'react-bootstrap/Form';


const Authenticator = () => {
    const [step, setStep] = useState(1);
    const [selectedCard, setSelectedCard] = useState("email");
    const [value, setValue] = useState("");

    const navigate = useNavigate();

    // move to the next step
    const handleNext = () => {
        if (step < 3) {
            setStep(step + 1);
        }
    };

    // move to previous step
    const handleBack = () => {
        if (step > 1) {
            setStep(step - 1);
        }
    };

    // card selector
    const handleCardClick = (cardName) => {
        setSelectedCard(cardName);
    };

    // data used for valitation(on "Confirmar" button)
    const handleValidation = () => {
        console.log("method: ", selectedCard);
        console.log("code : ", value);
        setValue("")

        navigate('/profile');
    };

    const handleInputChange = (e) => {
        const inputValue = e.target.value;

        // only numbers and limit to 6
        const numericValue = inputValue.replace(/\D/g, "").slice(0, 6);

        // add dash after 3 numbers
        let formattedValue = numericValue;
        if (numericValue.length > 3) {
            formattedValue = `${numericValue.slice(0, 3)}-${numericValue.slice(3)}`;
        }
        setValue(formattedValue);
    };


    return (
        <div className="h-100 d-flex justify-content-center align-items-center">
            <Row className="w-100">
                <Col>
                    {/* render each card depending on the current value of the step */}
                    {step === 1 && (
                        <div className='d-flex justify-content-center align-items-center'>
                            <Card className="bg-transparent">
                                <Card.Body style={{ backgroundColor: " #17296B" }} className="rounded-2 custom-card">
                                    <Row className="align-items-center">
                                        <Col xs="auto">
                                            <FaAngleLeft className="fs-2 text-white" roundedCircle onClick={handleBack} style={{ cursor: "pointer" }} />
                                        </Col>
                                        <Col className='text-center'>
                                            <b style={{
                                                opacity: "1",
                                                color: "white",
                                                fontFamily: "sans-serif",
                                                fontSize: "clamp(20px, 1vw, 24px)",
                                            }}>Autenticador</b>
                                        </Col>
                                        <Col xs="auto" />
                                    </Row>
                                    <Row className="justify-content-center align-items-center">
                                        <hr style={{ opacity: "1", border: "1px solid white" }} className="mt-0 col-10" />
                                    </Row>
                                    <Container>
                                        <Row>
                                            <Col>
                                                <b className="card-title" style={{ color: "white", fontSize: 'clamp(16px, 4vw, 20px)', lineHeight: "0.7" }}>Proteja a sua conta em apenas dois passos</b>
                                            </Col>
                                        </Row>
                                        <Row className="mt-3 d-flex justify-content-center align-items-top">
                                            <Col xs="2" className="mt-1">
                                                <span
                                                    style={{
                                                        height: "35px",
                                                        width: "35px",
                                                        backgroundColor: "black",
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        textAlign: "center",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: "white",
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    1
                                                </span>
                                            </Col>
                                            <Col style={{ color: "white" }}>
                                                <b style={{ fontSize: "clamp(11px, 3vw, 14px)", opacity: "1" }}>Ative a autenticação em duas etapas na sua conta do AgilityHR</b>
                                                <p style={{ fontSize: "clamp(11px, 3vw, 13px)", opacity: "1" }} className="col-12 col-md-11">Utilize um método de verificação compatível (E-mail ou SMS) para receber um código de segurança.</p>
                                            </Col>
                                        </Row>
                                        <Row className="mt-2 d-flex justify-content-center align-items-top mb-3">
                                            <Col xs="2" className="mt-1">
                                                <span
                                                    style={{
                                                        height: "35px",
                                                        width: "35px",
                                                        backgroundColor: "black",
                                                        borderRadius: "50%",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: "white",
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    2
                                                </span>
                                            </Col>
                                            <Col style={{ color: "white" }}>
                                                <b style={{ fontSize: "clamp(11px, 3vw, 14px)", opacity: "1" }}>Introduza o código de confirmação</b>
                                                <p style={{ fontSize: "clamp(11px, 3vw, 13px)", opacity: "1" }} className="col-12 col-md-11">Insira o código enviado para o seu e-mail ou Nº de telemóvel para concluir a ativação. Pode desativar esta opção a qualquer momento nas definições.</p>
                                            </Col>
                                        </Row>
                                        <Row style={{ position: "absolute", bottom: "0" }} className='col-12 mb-5'>
                                            <Row className="d-flex justify-content-center align-items-center">
                                                <Button
                                                    variant="primary"
                                                    className="col-8 mt-2"
                                                    style={{ fontWeight: "bold", fontSize: "clamp(14px, 3vw, 16px)" }} // Responsive font size
                                                    onClick={handleNext}
                                                >
                                                    Próximo
                                                </Button>
                                            </Row>
                                            <Row className="mt-4 d-flex justify-content-center align-items-center">
                                                <Col className="col-3 bg-white" style={{ height: '10px' }}>
                                                    <div className="d-inline-block"></div>
                                                </Col>
                                                <Col className="col-1" />
                                                <Col className="col-3 bg-secondary h-10" style={{ height: '10px' }}>
                                                    <div className="d-inline-block"></div>
                                                </Col>
                                                <Col className="col-1" />
                                                <Col className="col-3 bg-secondary h-10" style={{ height: '10px' }}>
                                                    <div className="d-inline-block"></div>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Container>
                                </Card.Body>
                            </Card>
                            <Row style={{ position: "absolute", bottom: "0" }}>
                                <Col className="d-flex justify-content-center align-items-bottom text-white">
                                    <p style={{ fontSize: "clamp(12px, 3vw, 14px)" }}>Made by  <b style={{ fontSize: "clamp(13px, 3vw, 15px)" }}>AgilityHR</b></p>
                                </Col>
                            </Row>
                        </div>
                    )}

                    {step === 2 && (
                        <div className='d-flex justify-content-center align-items-center'>
                            <Card className="bg-transparent">
                                <Card.Body
                                    style={{
                                        backgroundColor: "#17296B",
                                    }}
                                    className="rounded-2 custom-card"
                                >
                                    <Row className="align-items-center">
                                        <Col xs="auto">
                                            <FaAngleLeft className="fs-2 text-white" roundedCircle onClick={handleBack} style={{ cursor: "pointer" }} />
                                        </Col>
                                        <Col className='text-center'>
                                            <b style={{
                                                opacity: "1",
                                                color: "white",
                                                fontFamily: "sans-serif",
                                                fontSize: "clamp(20px, 1vw, 24px)",
                                            }}>Autenticador</b>
                                        </Col>
                                        <Col xs="auto" />
                                    </Row>
                                    <Row className="justify-content-center align-items-center">
                                        <hr style={{ opacity: "1", border: "1px solid white" }} className="mt-0 col-10" />
                                    </Row>
                                    <Container>
                                        <Row>
                                            <Col>
                                                <b
                                                    className="card-title"
                                                    style={{
                                                        color: "white",
                                                        fontSize: "clamp(16px, 4vw, 20px)",
                                                        lineHeight: "0.7",
                                                    }}
                                                >
                                                    Proteja a sua conta em apenas dois passos
                                                </b>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="mt-3">
                                                <p className="text-white" style={{ fontSize: "clamp(12px, 3vw, 14px)" }}>
                                                    Selecione uma das seguintes opções:
                                                </p>
                                            </Col>
                                        </Row>
                                        <Row className="mt-1 d-flex justify-content-center align-items-center">
                                            <Col className="custom-col">
                                                <Card
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        border: `2px solid ${selectedCard === "email" ? "white" : "#00B2FF"}`,
                                                        position: "relative",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => handleCardClick("email")}
                                                    className="decision-card rounded-3 d-flex justify-content-center align-items-center"
                                                >
                                                    <FaEnvelope className="fs-2 text-white" />
                                                </Card>
                                            </Col>
                                            <Col className="custom-col">
                                                <Card
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        border: `2px solid ${selectedCard === "sms" ? "white" : "#00B2FF"}`,
                                                        position: "relative",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => handleCardClick("sms")}
                                                    className="decision-card rounded-3 d-flex justify-content-center align-items-center"
                                                >
                                                    <FaSms className="fs-2 text-white" />
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row style={{ position: "absolute", bottom: "0" }} className="col-12 mb-5">
                                            <Row className="d-flex justify-content-center align-items-center">
                                                <Button
                                                    variant="primary"
                                                    className="col-8 mt-2"
                                                    style={{ fontWeight: "bold", fontSize: "clamp(14px, 3vw, 16px)" }}
                                                    onClick={handleNext}
                                                >
                                                    Próximo
                                                </Button>
                                            </Row>

                                            <Row className="mt-4 d-flex justify-content-center align-items-center">
                                                <Col className="col-3 bg-secondary" style={{ height: "10px" }}></Col>
                                                <Col className="col-1" />
                                                <Col className="col-3 bg-white" style={{ height: "10px" }}></Col>
                                                <Col className="col-1" />
                                                <Col className="col-3 bg-secondary" style={{ height: "10px" }}></Col>
                                            </Row>
                                        </Row>
                                    </Container>
                                </Card.Body>
                            </Card>
                            <Row style={{ position: "absolute", bottom: "0" }}>
                                <Col className="d-flex justify-content-center align-items-bottom text-white">
                                    <p style={{ fontSize: "clamp(12px, 3vw, 14px)" }}>Made by  <b style={{ fontSize: "clamp(13px, 3vw, 15px)" }}>AgilityHR</b></p>
                                </Col>
                            </Row>
                        </div>
                    )}

                    {step === 3 && (
                        <div className='d-flex justify-content-center align-items-center'>
                            <Card className="bg-transparent">
                                <Card.Body style={{ backgroundColor: " #17296B" }} className="rounded-2 custom-card">
                                    <Row className="align-items-center">
                                        <Col xs="auto">
                                            <FaAngleLeft className="fs-2 text-white" roundedCircle onClick={handleBack} style={{ cursor: "pointer" }} />
                                        </Col>
                                        <Col className='text-center'>
                                            <b style={{
                                                opacity: "1",
                                                color: "white",
                                                fontFamily: "sans-serif",
                                                fontSize: "clamp(20px, 1vw, 24px)",
                                            }}>Autenticador</b>
                                        </Col>
                                        <Col xs="auto" />
                                    </Row>
                                    <Row className="justify-content-center align-items-center">
                                        <hr style={{ opacity: "1", border: "1px solid white" }} className="mt-0 col-10" />
                                    </Row>
                                    <Container >
                                        <Row>
                                            <Col>
                                                <b className="card-title" style={{ color: "white", fontSize: '20px', lineHeight: "0.7" }}>Proteja a sua conta em apenas dois passos </b>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='mt-3'>
                                                <p className='text-white' style={{ fontSize: "14px" }}>
                                                    {selectedCard === "email"
                                                        ? "Enviámos um código de verificação para o seu e-mail."
                                                        : "Enviámos um código de verificação para o seu telemovel por sms."}
                                                </p>
                                                <p className='text-white' style={{ fontSize: "14px" }}>Introduza o código recebido para continuar:</p>
                                            </Col>
                                        </Row>
                                        <Row className="mt-1 d-flex justify-content-center align-items-top">
                                            <Col className='col-10'>
                                                <Form.Control
                                                    type="text"
                                                    value={value}
                                                    onChange={handleInputChange}
                                                    placeholder="000-000"
                                                    className="custom-input text-white"
                                                    style={{
                                                        backgroundColor: '#2B2B2B',
                                                        textAlign: 'center',
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row style={{ position: "absolute", bottom: "0" }} className="col-12 mb-5">
                                            <Row className="d-flex justify-content-center align-items-center">
                                                <Button
                                                    variant="primary"
                                                    className="col-8 mt-2"
                                                    style={{ fontWeight: "bold", fontSize: "clamp(14px, 3vw, 16px)" }}
                                                    onClick={() => handleValidation()}
                                                >
                                                    Concluir
                                                </Button>
                                            </Row>

                                            <Row className="mt-4 d-flex justify-content-center align-items-center">
                                                <Col className="col-3 bg-secondary" style={{ height: "10px" }}></Col>
                                                <Col className="col-1" />
                                                <Col className="col-3 bg-secondary" style={{ height: "10px" }}></Col>
                                                <Col className="col-1" />
                                                <Col className="col-3 bg-white" style={{ height: "10px" }}></Col>
                                            </Row>
                                        </Row>
                                    </Container>
                                </Card.Body>
                            </Card>
                            <Row style={{ position: "absolute", bottom: "0" }}>
                                <Col className="d-flex justify-content-center align-items-bottom text-white">
                                    <p style={{ fontSize: "clamp(12px, 3vw, 14px)" }}>Made by  <b style={{ fontSize: "clamp(13px, 3vw, 15px)" }}>AgilityHR</b></p>
                                </Col>
                            </Row>
                        </div>
                    )}
                </Col>
            </Row>
        </div>
    );
}

export default Authenticator;